import { useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { Eyebrow } from '../ui/Eyebrow.jsx';
import { Button } from '../ui/Button.jsx';
import { Icon } from '../ui/Icon.jsx';
import { navLinks } from '../../data/site.js';
import { useLockBodyScroll } from '../../hooks/useLockBodyScroll.js';
import styles from './MobileNav.module.css';

export function MobileNav({ id, open, onClose }) {
  const panelRef = useRef(null);
  const firstLinkRef = useRef(null);

  useLockBodyScroll(open);

  // Focus moves into the panel on open. Focus on close is restored by the
  // caller, which owns the toggle button the focus belongs back on.
  useEffect(() => {
    if (open) firstLinkRef.current?.focus();
  }, [open]);

  return (
    <div
      id={id}
      ref={panelRef}
      className={styles.nav}
      data-open={open}
      /* Kept in the DOM but taken out of the tab order and the
         accessibility tree when closed, so the slide transition still has
         something to animate. */
      {...(open ? null : { inert: true, 'aria-hidden': true })}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
    >
      <div className={styles.top}>
        <Eyebrow onDark animated={false}>Menu</Eyebrow>
        <button type="button" className={styles.close} aria-label="Close menu" onClick={onClose}>
          <Icon name="close" strokeWidth={1.75} />
        </button>
      </div>

      <nav className={styles.links} aria-label="Mobile">
        {navLinks.map(({ to, label }, i) => (
          <Link key={to} to={to} ref={i === 0 ? firstLinkRef : undefined} onClick={onClose}>
            {label}
          </Link>
        ))}
      </nav>

      <div className={styles.cta}>
        <Button to="/contact" variant="onDark" icon={null} onClick={onClose}>
          Get in Touch
        </Button>
      </div>
    </div>
  );
}
